<template>
  <div class="thumb-slider-gallery">
    <div class="main-image">
      <img :src="currentImage" alt="Main Image" />
    </div>
    <div
      v-swiper:mySwiper="swiperOption"
      class="swiper-container w-10/12 mx-auto mt-1"
    >
      <div class="swiper-wrapper">
        <a v-for="(image, index) in images" :key="index" class="swiper-slide" :class="{ current: index === currentIndex }" @click="changeImage(index)">
          <img :src="image"/>
        </a>
      </div>
    </div>
    <div class="navigation-wrapper">
      <div v-if="showPrevButton" class="swiper-button-prev swiper-button-white" @click="moveToPrevImage"></div>
      <div v-if="showNextButton" class="swiper-button-next swiper-button-white" @click="moveToNextImage"></div>
    </div>
  </div>
</template>
  <script>  

  export default {
    props: {
      images: { type: Array, required: true },
    },
    data () {
      return {
        currentIndex: 0,
        swiperOption: {
          direction: 'horizontal',
          slidesPerView: 5,
          spaceBetween: 5,
          loop: false,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 5
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 5
            }
          }
        }
      };
    },
    computed: {
      currentImage () {
        return this.images[this.currentIndex];
      },
      showPrevButton () {
        return this.currentIndex > 0;
      },
      showNextButton () {
        return this.currentIndex < this.images.length - 1;
      },
    },
    methods: {
      changeImage (index) {
        this.currentIndex = index;
        this.mySwiper.slideTo(this.currentIndex);
      },
      moveToPrevImage () {
        this.changeImage(this.currentIndex - 1);
      },
      moveToNextImage () {
        this.changeImage(this.currentIndex + 1);
      }
    }
  };
  </script>
  
  <style lang="sass" scoped>
  $sliderHeight: 120px
  .thumb-slider-gallery
    width: 100%
    .main-image
      img
        @apply rounded w-full
        aspect-ratio: 3 / 2
        object-fit: cover
  
    .swiper-container
      height: $sliderHeight
      @apply w-full overflow-hidden
      .swiper-slide
        @apply cursor-pointer relative w-full h-full
        &:before
            content: ''
            @apply absolute h-full bg-black opacity-60 rounded
            left: 0
            right: 0
  
        &.current:before
          @apply bg-transparent
        img
          @apply h-full w-full rounded
          object-fit: cover
  
    .navigation-wrapper
      @apply absolute bottom-0 w-full
      height: $sliderHeight
    .swiper-button-next, .swiper-button-prev
      @apply rounded-full bg-secondary opacity-60
      height: 3.5rem
      width: 3.5rem
      &:after
        font-size: 2rem
        @apply text-white font-bold
    .swiper-button-next
      right: -1.5rem
    .swiper-button-prev
      left: -1.5rem
  </style>
  